import {useEffect} from 'react';
import {DefaultMetaTags} from '@common/seo/default-meta-tags';
import {
  HeroHeader,
  LaunchKitSection,
  MoreWaysSection,
  TemplatesBandSection,
  McpSection,
  HowItWorksSection,
  // FeaturesSection, — commented out, not part of the concept design
  // StatsSection, — commented out, not part of the concept design
  // TestimonialsSection, — commented out, not part of the concept design
  // PricingSection, — commented out, not part of the concept design
  // AddonsSection, — commented out, not part of the concept design
  CtaSection,
} from './components';

export function LandingPage() {
  // Load fonts
  useEffect(() => {
    const fontsLink = document.createElement('link');
    fontsLink.href =
      'https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&family=Playfair+Display:ital,wght@0,500;0,600;0,700;1,600&display=swap';
    fontsLink.rel = 'stylesheet';
    document.head.appendChild(fontsLink);

    return () => {
      fontsLink.remove();
    };
  }, []);

  // Intersection Observer for fade-up animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {threshold: 0.1, rootMargin: '0px 0px -40px 0px'}
    );

    const fadeElements = document.querySelectorAll('.fade-up');
    fadeElements.forEach(el => observer.observe(el));

    return () => {
      fadeElements.forEach(el => observer.unobserve(el));
    };
  }, []);

  // Handle anchor scrolling
  useEffect(() => {
    const handleAnchorScroll = () => {
      const hash = window.location.hash;
      if (hash) {
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'start'});
          }
        }, 100);
      }
    };

    handleAnchorScroll();

    const handleHashChange = () => handleAnchorScroll();
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  // Smooth scroll for anchor links
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href^="#"]');
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (href) {
          const el = document.querySelector(href);
          if (el) {
            e.preventDefault();
            el.scrollIntoView({behavior: 'smooth', block: 'start'});
          }
        }
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <div className="landing-page">
      <DefaultMetaTags />
      <HeroHeader />
      <LaunchKitSection />
      <MoreWaysSection />
      <TemplatesBandSection />
      <McpSection />
      <HowItWorksSection />
      {/* <FeaturesSection /> — concept design has no features section on the home page */}
      {/* <StatsSection /> — concept design has no stats section on the home page */}
      {/* <TestimonialsSection /> — concept design has no testimonials section on the home page */}
      {/* <PricingSection /> — concept design has no pricing section on the home page */}
      {/* <AddonsSection /> — concept design has no add-ons section on the home page */}
      <CtaSection />
    </div>
  );
}
